export function isSubdomain () {
  if (process.env.NODE_ENV === 'development') {
    return window.location.hostname.indexOf('.localhost') > -1
  } else {
    return window.location.hostname.endsWith('.flt.onl')
  }
}

export function isPortal () {
  if (process.env.NODE_ENV === 'development') {
    return window.location.hostname.indexOf('.localhost') > -1
  } else {
    return window.location.hostname.endsWith('flt.onl')
  }
}